module.exports = __webpack_public_path__ + "static/media/about-image.863388f9.png";